<template>
    <div class="review-images" aria-label="评价照片">
        <div v-for="(entry, index) in entries" :key="entry.imageId" class="image-entry">
            <button type="button" :disabled="blocked || entry.loading" :aria-label="'预览评价照片 ' + (index + 1)" @click="open(entry, $event)"><img v-if="entry.url" :src="entry.url" :alt="'评价照片 ' + (index + 1)" loading="lazy" @error="imageFailed(entry)"><span v-else>照片 {{ index + 1 }}</span></button>
            <span v-if="entry.loading" role="status">正在读取…</span>
        </div>
        <p v-if="error" class="image-error" role="alert">{{ error }}</p>
        <div v-if="preview" class="image-preview" role="dialog" aria-modal="true" aria-label="评价照片预览" @keydown.esc="close" @keydown.tab.prevent="focusClose">
            <button ref="close" type="button" @click="close">关闭预览</button>
            <img :src="preview.url" alt="评价照片预览" @error="imageFailed(preview)">
        </div>
    </div>
</template>
<script>
import serviceReviews from '@/tool/serviceReviews';

export default {
    name: 'ServiceReviewImages',
    props: { reviewId: { type: String, required: true }, images: { type: Array, default: () => [] } },
    data: () => ({ entries: [], preview: null, error: '', blocked: false, generation: 0, intent: 0, opener: null }),
    computed: { target() { return this.reviewId + ':' + JSON.stringify(this.images); } },
    watch: { target: { immediate: true, handler() {
        this.generation += 1; this.intent += 1; this.preview = null; this.error = ''; this.blocked = false;
        this.entries = this.images.filter(image => typeof image.imageId === 'string' && /^[1-9]\d*$/.test(image.imageId)).map(image => ({ imageId: image.imageId, url: image.url || '', loading: false, attempts: 0 }));
    } } },
    beforeDestroy() { this.generation += 1; this.intent += 1; },
    methods: {
        focusClose() { if (this.$refs.close) this.$refs.close.focus(); },
        close() { this.intent += 1; this.preview = null; if (this.opener && this.opener.isConnected) this.opener.focus(); },
        async sign(entry) {
            if (this.blocked || entry.loading || !this.entries.includes(entry) || entry.attempts >= 2) return false;
            const generation = this.generation;
            entry.loading = true; entry.attempts += 1;
            try {
                const value = await serviceReviews.accessUrl(this.reviewId, entry.imageId);
                if (generation !== this.generation || !this.entries.includes(entry)) return false;
                if (!value || value.imageId !== entry.imageId || typeof value.url !== 'string' || !value.url) throw new Error('图片地址未确认');
                entry.url = value.url; this.error = ''; return true;
            } catch (error) {
                if (generation !== this.generation) return false;
                entry.url = ''; this.preview = null; this.error = '照片暂时无法读取，请刷新评价状态后重试。';
                const code = error.code || error.response && error.response.status;
                if ([404, 409].includes(code)) { this.blocked = true; this.entries.forEach(item => { item.url = ''; }); this.$emit('refresh'); }
                return false;
            } finally { if (generation === this.generation) entry.loading = false; }
        },
        async open(entry, event) {
            if (this.blocked || entry.loading) return;
            const generation = this.generation, intent = ++this.intent;
            this.opener = event && event.currentTarget;
            // Opening is an explicit new authorization intent. An image load error
            // may refresh once more; repeated failed object reads stop automatically.
            entry.attempts = 0;
            if (await this.sign(entry) && generation === this.generation && intent === this.intent && !this.blocked) {
                this.preview = entry; this.$nextTick(this.focusClose);
            }
        },
        async imageFailed(entry) {
            if (this.blocked || !this.entries.includes(entry) || entry.loading) return;
            entry.url = '';
            if (entry.attempts >= 2) { this.preview = null; this.error = '照片读取失败，请刷新评价状态后重试。'; return; }
            await this.sign(entry);
        },
    },
};
</script>
<style scoped>
.review-images { display:flex; flex-wrap:wrap; gap:8px; margin-top:12px; }.image-entry { display:flex; flex-direction:column; max-width:100%; }.image-entry button { width:88px; height:88px; padding:0; overflow:hidden; }.image-entry img { width:100%; height:100%; object-fit:cover; }
button { min-height:44px; padding:8px 14px; border:1px solid #c8b6d5; border-radius:7px; color:#624385; background:#fff; cursor:pointer; font:inherit; }button:focus-visible { outline:3px solid #76528e; outline-offset:3px; }button:disabled { opacity:.65; cursor:wait; }.image-error { color:#a32940; width:100%; }
.image-preview { position:fixed; inset:0; z-index:2500; box-sizing:border-box; display:flex; flex-direction:column; align-items:center; gap:12px; padding:max(16px,env(safe-area-inset-top)) max(16px,env(safe-area-inset-right)) max(16px,env(safe-area-inset-bottom)) max(16px,env(safe-area-inset-left)); background:rgba(24,20,29,.94); }.image-preview img { min-height:0; max-width:100%; max-height:calc(100% - 60px); object-fit:contain; }.image-preview button { flex-shrink:0; }
</style>
